<template>
  <div id="about">
    <div class="p2 full-height font-size-large link-border">
      <span v-html="pageContent"></span>
      <div class="subdued mt3">Design & Development: <a href="//alanwoo.ca">Alan Woo</a></div>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'

export default {

  name: 'About',

  data () {
    return {
      pageContent: null
    }
  },

  created () {
    Axios.get(`${process.env.API_ROOT}/about`)
      .then(response => {
        this.pageContent = response.data
      })
      .catch(error => {
        return error
      })
  }
}
</script>

<style lang="css">
#about a {
  border-bottom: 1px solid var(--color-green);
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue